import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import * as _ from 'lodash';
@Component({
  selector: 'app-receipt-supporting-docs-report',
  templateUrl: './receipt-supporting-docs-report.component.html',
  styleUrls: ['./receipt-supporting-docs-report.component.css']
})
export class ReceiptSupportingDocsReportComponent implements OnInit {
  data: any;
  arrCompany: any[] = [];
  arrPaytype: any[] = [];
  arrTreq: any[] = [];
  settings_PayType = {};
  settings_com = {};
  txtPaytype: any[] = [];
  txtCom: any[] = [];
  sCom: any[] = [];
  sPaytype: any[] = [];
  IsCom: boolean = false;
  IsPaytype: boolean = false;
  txtrangDate: any[] = [];
  txtReceipt: string = null;
  txtRemark: string = null;
  IsReqNo: boolean = false;
  txtReqNo1: string = null;
  txtReqNo2: string = null;
  sReqNo1: string = null;
  sReqNo2: string = null;
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  minDate: Date = new Date();
  maxDate: Date = new Date();
  _ArrData: any;
  _ArrDatatotal: any[] = [];
  _ArrDatatotalBind: any[] = [];
  //Set grid
  _ArrDataBind = [];
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortAsc = "fas fa-sort-up";
  IcoSortDesc = "fas fa-sort-down";
  //Head colums
  Columns = [
    { ColumnName: "Request No. ", SortField: "sRequestCode", Width: "100px" },
    { ColumnName: "Request Date ", SortField: "dRequestDate", Width: "110px" },
    { ColumnName: "Requester ", SortField: "fullname", Width: "200px" },
    { ColumnName: "Status ", SortField: "sStatusName_SSC", Width: "140px" },
    { ColumnName: "Due Date ", SortField: "dDueDate", Width: "110px" },
    { ColumnName: "Vendor Name ", SortField: "VENDORNAME", Width: "200px" },
    { ColumnName: "Payment Type ", SortField: "nReqType", Width: "150px" },
    { ColumnName: "Currency ", SortField: "sCurrency", Width: "100px" },
    { ColumnName: "Amount excl. VAT ", SortField: "nGrandTotalAmt", Width: "150px" },
    { ColumnName: "VAT ", SortField: "nGrandTotalAmtVat", Width: "150px" },
    { ColumnName: "Amount incl. VAT ", SortField: "nGrandTotalAmtInvoice", Width: "150px" },
    { ColumnName: "Description ", SortField: "sDocHeader", Width: "200px" },
    { ColumnName: "UG ", SortField: "nSSCUrgent", Width: "50px" },
    { ColumnName: "Receipt/Supporting Docs ", SortField: "IsSupportingDocument", Width: "100px" },
    { ColumnName: "Remark ", SortField: "sSupportingDocument", Width: "150px" },
    { ColumnName: "Completed Date ", SortField: "dUpdateDate", Width: "80px" },
  ]
  constructor(private http: HttpClient
    , private formBuilder: FormBuilder
    , private SW: SWAlertService
    , private activatedRoute: ActivatedRoute
    , private router: Router
    , private System: TSFuntionService) { }

  ngOnInit() {
    this.getAutocomplete();
    this.settings_PayType = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false

    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    const ua = this.System.GetUserStorage();
    if (ua) {
      this.txtCom = [];
      this.sCom = [];
      ua.lstCompCode.forEach(f =>
        {
          this.txtCom.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
          this.sCom.push(f.sCompCode)
        }
      );
    }

    let nsize = document.getElementById('dvbtn').offsetWidth;
    let width = "width:" + nsize + "px";
    document.getElementById('dvtable2').setAttribute("style", width);
    document.getElementById('tbExample').setAttribute("style", "width:2200px");
    this.minDate.setDate(this.minDate.getDate() - 90);
    this.maxDate.setDate(this.maxDate.getDate());
    this.txtrangDate = [this.minDate, this.maxDate];
    this.System.UnBlockUI();
  }

  getAutocomplete() {
    this.System.BlockUI();
    this.http.get<any>(this.System.SiteName + "api/ReceiptDocsReport/getAutoData").toPromise().then(res => {
      this.System.UnBlockUI();
      this.data = res;
      const ua = this.System.GetUserStorage();
      if ([3, 4, 5].includes(ua.nRole)) {
        this.arrCompany = this.data.lstCompany.filter(f => f.COMPANY_CODE === ua.sCompCode);
      }
      else {
        this.arrCompany = this.data.lstCompany;
      }
      this.arrPaytype = this.data.lstPayType;
      this.arrTreq = this.data.lstTreq;
    });
  }

  onselectpaytype(item: any, name: any) {
    let _this = this;
    if (name == 'txtPaytype') {
      let npaytype = this.txtPaytype.map(f => Number.parseInt(f.nReqType))
      this.arrTreq = this.data.lstTreq.filter(function (index) { return npaytype.includes(index.nReqType) });
      if (this.txtCom.length != 0) {
        this.sCom = this.txtCom.map(f => f.COMPANY_CODE)
        this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
      }
    }
    if (name == 'txtCom') {
      this.sCom = this.txtCom.map(f => f.COMPANY_CODE)
      this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
  }

  onSelectAll(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      this.sCom = item.map(f => f.COMPANY_CODE)
      this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtPaytype') {
      let npaytype = item.map(f => Number.parseInt(f.nReqType))
      this.arrTreq = this.data.lstTreq.filter(function (index) { return npaytype.includes(index.nReqType) });
    }
  }

  DeSelect(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      let com = item.COMPANY_CODE
      this.sCom = this.sCom.filter(function (index) { return !com.includes(index) });
      this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtPaytype') {
      let npaytype = item.nReqType
      this.arrTreq = this.data.lstTreq.filter(function (index) { return !npaytype.includes(index.nReqType) });
    }
  }

  onDeSelectAll(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      this.sCom = []
    }
    if (name == 'txtPaytype') {
      this.txtPaytype = [];
    }
    this.arrTreq = this.data.lstTreq;
  }

  typeaheadNoResults(event, index) {
    switch (index) {
      case "txtCom":
        this.IsCom = event;
        break
      case "txtPreparer":
        this.IsPaytype = event;
        break
      case "txtReqNo":
        this.IsReqNo = event;
        break
    }
  }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    var Pass = true;
    switch (index) {
      case "txtCom":
        if (this.txtCom != event.item.COMPANY_NAME) {
          Pass = false

        }
        if (Pass) {
          this.onSelect(event, index);
        } else {
          this.txtCom = [];
          this.sCom = [];
        }
        break
      case "txtPreparer":
        if (this.IsPaytype) {
          this.txtPaytype = null;
        }
        if (this.txtPaytype.length != 0) {
          this.txtPaytype = [];
          this.sPaytype = [];
        }
        break
      case "txtReqNo1":
        if (this.txtReqNo1 != event.item.sRequestCode) {
          Pass = false
        }
        if (Pass) {
          this.onSelect(event, index);
        } else {
          this.txtReqNo1 = null;
          this.sReqNo1 = null;
        }

        break
      case "txtReqNo2":
        if (this.txtReqNo2 != event.item.sRequestCode) {
          Pass = false
        }
        if (Pass) {
          this.onSelect(event, index);
        } else {
          this.txtReqNo2 = null;
          this.sReqNo2 = null;
        }

        break

    }
  }
  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case "txtCom":
        this.sCom = event.item.COMPANY_CODE;
        this.arrTreq = this.arrTreq.filter(f => f.sCompCode == this.sCom);
        break
      case "txtReqNo1":
        this.sReqNo1 = event.item.sRequestCode;
        break
      case "txtReqNo2":
        this.sReqNo2 = event.item.sRequestCode;
        break
    }
  }

  Onsearch() {
    this.System.BlockUI();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let arrType = this.txtPaytype.map(f => f.nReqType)
    let data = {
      arrComcode: this.sCom
      , sReqNo1: this.sReqNo1
      , sReqNo2: this.sReqNo2
      , arrpaytype: arrType
      , RangDate: this.txtrangDate
      , IsReceipt: this.txtReceipt
      , sRemark: this.txtRemark
    }
    let ITEM = JSON.stringify(data)
    this._ArrData = [];
    this._ArrDatatotalBind = [];
    this.http.post(this.System.SiteName + 'api/ReceiptDocsReport/searchData', ITEM, { headers, responseType: 'json' }).subscribe(res => {
      this.System.UnBlockUI();
      var data = res == null ? [] : res;
      this._ArrData = data;
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({
      sReqUG: val.IsReqUrgent == true ? "UG" : null
      , sUG: val.IsSSCUrgent == true ? "UG" : null
    }, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
  }

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });

  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  //#endregion

  ExportExcel() {
    const link = document.createElement('a');
    link.target = '_blank'
    link.href = this.System.SiteName + "api/ReceiptDocsReport/CreateReportExpected";
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  OnClear() {
    this.txtCom = [];
    this.txtReqNo1 = null;
    this.txtReqNo2 = null;
    this.txtPaytype = [];
    this.txtrangDate = [];
    this._ArrDataBind = [];
    this._ArrDatatotalBind = [];
    this.sCom = [];
    this.sReqNo1 = null;
    this.sReqNo2 = null;
    this.txtReceipt = null;
    this.txtRemark = null;
    this.txtrangDate = [this.minDate, this.maxDate];
    const ua = this.System.GetUserStorage();
    if (ua) {
      ua.lstCompCode.forEach(f =>
        {
          this.txtCom.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
          this.sCom.push(f.sCompCode)
        }
      );
    }
  }

}
